<template>
  <div style="display: flex;justify-content: space-between;flex-wrap: wrap;">
        
      <div class="two">
        <div class="header">
          <span>总成交额（USDT）</span>
          <el-tooltip effect="dark"  placement="top">
            <div slot="content">总成交额：统计所有合约交易对指定<br/>时间段内的总交易额（折合USDT; 周<br/>环比：近7天A与上个7天B交易额对<br/>比，（A - B）/B 日环比：昨天A与前<br/>天B交易额对比，（A - B）/B; 日均成<br/>交额：总成交额 / 总时间段（天）</div>
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
         
        </div>
        <!-- <el-divider></el-divider> -->
        <!-- <Line1></Line1> -->
        <div class="con">
          <div >
            <h2>{{echartsData.totalLimit}}</h2>
          </div>
          <div class="rate">
            <div>
              <span>周同比</span>
            <span>
              <i v-if="echartsData.weekThan>0" class="el-icon-caret-top"></i>
              <i v-else class="el-icon-caret-bottom"></i>
              {{echartsData.weekThan}}%
            </span>
            </div>
            
            <div>
              <span>日环比</span>
            <span style="margin: 0;">
              <i v-if="echartsData.dayThan<0" class="el-icon-caret-bottom"></i>
              <i v-else class="el-icon-caret-top"></i>
              {{echartsData.dayThan}}%
            </span>
            </div>
          </div>
        </div>
        <div class="bor"></div>
        <div class="footer">
          <span>日均成交额</span>
          <span style="font-weight:700;margin-left: 20px;">{{echartsData.avgAmount}}</span>
        </div>


        </div>
        <div class="two">
          <div class="header">
          <span>交易额（USDT）</span>
          <el-tooltip effect="dark"  placement="top">
            <div slot="content">交易额：统计所有合约交易对指定<br/>时间段内的总交易额（折合USDT; 周<br/>环比：近7天A与上个7天B交易额对<br/>比，（A - B）/B 日环比：昨天A与前<br/>天B交易额对比，（A - B）/B; 日均成<br/>交额：总成交额 / 总时间段（天）</div>
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
          </div>
          <Line2  :symbol="symbol" :start="startTime" :end="endTime" :type="type"></Line2>
          <div class="bor"></div>
          <div class="footer">
            <span >日均交易额</span>
            <span style="font-weight:700;margin-left: 20px;">{{echartsData.avgAmount}}</span>
          </div>
        </div>
        <div class="two">
          <div class="header">
            <!-- <el-tabs class="tab-head" size="small" v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane class="tab-content" label="交易人数" name="first">
              <div>gaga</div>
             
            </el-tab-pane>
            <el-tab-pane label="交易次数" name="second">交易次数</el-tab-pane>
          </el-tabs> -->
          <p>
            <span @click="personNum" :class={isActive:isShow}>交易人数</span>
            |
            <span @click="timesNum" :class={isActive:!isShow}>交易次数</span>
          </p>
          
          <el-tooltip effect="dark"  placement="top">
            <div slot="content">总成交额：统计所有合约交易对指定<br/>时间段内的总交易额（折合USDT; 周<br/>环比：近7天A与上个7天B交易额对<br/>比，（A - B）/B 日环比：昨天A与前<br/>天B交易额对比，（A - B）/B; 日均成<br/>交额：总成交额 / 总时间段（天）</div>
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
          </div>
          <Line3 v-show="isShow" :symbol="symbol" :start="startTime" :end="endTime" :type="type"></Line3>
          <Line4 v-show="!isShow" :symbol="symbol" :start="startTime" :end="endTime" :type="type" ></Line4>
          <div class="bor"></div>
        <div class="footer">
          
          <span v-show="isShow">日均交易人数 &nbsp;&nbsp;<span style="font-weight: 700;">{{transcationData.avgTradeUserNumber}}</span></span>
          <span v-show="!isShow">日均交易次数&nbsp;&nbsp;{{transcationData.avgTradeNumber}}</span>
        </div>
        </div>
      
      
 
 </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Pagination from 'components/pagination';
import Line2 from '../line2/index.vue'
import Line1 from '../line1/index.vue'
import Line3 from '../line3/index.vue'
import Line4 from '../line4/index.vue'
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
// import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
// import { BarChart } from 'echarts/charts';

export default {
  name: 'reportList',
  props:['startTime','endTime','symbol','type'],
  data() {
    return {
      datas:{},
      activeName: 'first',
      isShow:true
    }
  },
 
  components: {
    Pagination,Line2,Line1,Line3,Line4
  },
  created () {
    // this.getTurnover({ 
    // endTime: this.startTime,
    // startTime: this.endTime,
    // symbol: "",
    // type: this.type})
    // this.datas=this.echartsData.avgAmountList
  },
  // watch: {
  //   startTime:{
  //     handler(val,oldVal){
  //       if(val){
  //         this.getTurnover({ 
  //         endTime: this.startTime,
  //         startTime: val,
  //         symbol: this.symbol,
  //         type: 0}).then(res=>{
  //           console.log('dddd',res);
  //         this.datas=res.data
  //         })
  //       }
  //     },

  //   }
  // },
  mounted () {

  },
  computed: {
    ...mapState('report',['echartsData','transcationData'])
  },
  methods: {
    ...mapActions('report',['getTurnover']),
    handleClick(tab, event) {
        console.log(tab, event);
      },
      personNum(){
        this.isShow=true
        //同步更新图表，自适应大小
        this.$nextTick(()=>{
          var myEvent = new Event("resize");
        window.dispatchEvent(myEvent);
        })
      },
      timesNum(){
        this.isShow=false
        this.$nextTick(()=>{
          var myEvent = new Event("resize");
        window.dispatchEvent(myEvent);
        })
      }
   
   
  }
};
</script>

<style lang="less" scoped>

  
    .two{
      box-sizing: border-box;
      width: 32%;
      height: 300px;
      // margin-top: 10px;
      // padding: 10px;
      // border: 1px solid red;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
      cursor: pointer;
      // :hover{
      //   box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
      //  }
       .header{
        width: 100%;
        box-sizing: border-box;
        align-items: center;
        height: 50px;
        // line-height: 50px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        // background-color: aqua;
        position: relative;
        // .tab-head{
        //   margin-top: 80px;
        //   position: absolute;
        // }
        // .tab-content{
        //   width: 100%;
        //   height: 100px;
        // }
       }
       .lastCon{
        width: 100%;
        height: 200px;
        background-color: aqua;
       }
       .bor{
        width: 94%;
        border-top: 1px solid #eee;
        margin: 0 auto !important;
       }
       .con{
        height: 200px;
        width: 100%;
        padding: 20px;
        border-top: 1px solid #eee;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .rate{
          display: flex;
          justify-content: space-between;
          span{
            margin-right: 14px;
           
          }
        }
       }
       .el-icon-caret-top{
        color: green;
       }
       .el-icon-caret-bottom{
        color:red
       }
       .footer{
        box-sizing: border-box;
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding: 0 16px;
        // background-color: brown;
       }
       .isActive{
        color: skyblue;
       }
    }
    
</style>
